import { GET_COUNT_FOB_CONNECTION_API_URL, GET_COUNT_COUPLING_CONNECTION_API_URL, GET_COUNT_PON_BOX_CONNECTION_API_URL,
         GET_COUNT_WELL_CONNECTION_API_URL, GET_COUNT_PILLAR_CONNECTION_API_URL, GET_COUNT_CABLE_CONNECTION_API_URL, 
         GET_NODE_CONNECTION_API_URL} from "../../../OpticApiConfig";

// количество связей FOB
export const fetchFobConnectionCount = async (fobLocationId) => {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${GET_COUNT_FOB_CONNECTION_API_URL}?fobLocationId=${fobLocationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (response.ok) {
        const count = await response.json();
        return count; 
      } else {
        console.error("Ошибка ответа сервера:", response.statusText);
        return null; 
      }
    } catch (error) {
      console.error("Ошибка при получении количества файлов:", error);
      return null; 
    }
  };

  // количество связей COUPLING
export const fetchCouplingConnectionCount = async (couplingLocationId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_COUPLING_CONNECTION_API_URL}?couplingLocationId=${couplingLocationId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

 // количество связей PON-BOX
 export const fetchPonBoxConnectionCount = async (ponBoxLocationId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_PON_BOX_CONNECTION_API_URL}?ponBoxLocationId=${ponBoxLocationId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

 // количество связей WELL
 export const fetchWellConnectionCount = async (wellId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_WELL_CONNECTION_API_URL}?wellId=${wellId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

// количество связей PILLAR
export const fetchPillarConnectionCount = async (pillarId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_PILLAR_CONNECTION_API_URL}?pillarId=${pillarId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

// количество связей CABLE
export const fetchCableConnectionCount = async (highwayLineId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_CABLE_CONNECTION_API_URL}?highwayLineId=${highwayLineId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

 // количество связей NODE
 export const fetchNodeConnectionCount = async (hid, entrance) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_NODE_CONNECTION_API_URL}?hid=${hid}&entrance=${entrance}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};